import { render } from "./NotebookComponent.vue?vue&type=template&id=41a804f8"
import script from "./NotebookComponent.vue?vue&type=script&lang=js"
export * from "./NotebookComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__